<template>
  <div class="d-flex flex-column w-100">
    <table class="table table-bordered bg-white">
      <thead>
        <tr class="bg-violet text-white text-center p-3 text-uppercase">
          <th colspan="5">
            <h3 class="m-0">In forno</h3>
          </th>
        </tr>
        <tr class="text-center" v-if="ovenWorksGroupedByTestWorkQueuePhase.length > 0">
          <th class="fw-bold align-middle" nowrap scope="col">Prescrizione</th>
          <th class="fw-bold align-middle" nowrap scope="col">N. Elementi</th>
          <th class="fw-bold align-middle" nowrap scope="col">Materiale</th>
          <th class="fw-bold align-middle" nowrap scope="col">Colore</th>
          <th class="fw-bold align-middle" nowrap scope="col">Seleziona</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="ovenWorksGroupedByTestWorkQueuePhase.length > 0">
          <template v-for="(el, index) in ovenWorksGroupedByTestWorkQueuePhase" :key="`oven-${index}`">
            <tr class="text-center" :class="{'higthlight': el.checked}">
              <td>{{ el.works[0].number_text }} - {{ dateFormatter(el.delivery_date, { onlyDate: true, onlyTime: true, dash: false, iso: false }) }}</td>
              <td>{{ el.works.length }}</td>
              <td>{{ renderUniqueValues(el.works, 'material') }}</td>
              <td>{{ renderUniqueValues(el.works, 'code') }}</td>
              <td>
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="el.checked"
                >
              </td>
            </tr>
          </template>
        </template>
        <template v-else>
          <tr>
            <td colspan="5" class="text-center p-3 fw-bold">
              <div>Nessun elemento in forno</div>
              <small class="text-muted">Gli asset pronti per il forno compariranno qui dopo il download.</small>
            </td>
          </tr>
        </template>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="5" class="p-3">
            <button
              type="button"
              class="btn btn-violet text-uppercase w-100"
              :disabled="selectedOvenWorks.length === 0"
              @click="putSelectedWorksInOven()"
            >
              metti in forno
            </button>
          </td>
        </tr>
      </tfoot>
    </table>

    <table class="table table-bordered bg-white" id="scrollTop">
      <thead>
        <tr class="bg-violet text-white text-center p-3 text-uppercase">
          <th colspan="7" class="position-relative">
            <div class="position-absolute start-0 ms-2">
              <img class="sync" src="@/assets/icons/sync.svg" width="30" height="30" alt="sync" @click="orderByPriorityDate()">
            </div>
            <h3 class="m-0">Conclusione lavori</h3>
          </th>
        </tr>
        <tr class="text-center" v-if="worksGroupedByTestWorkQueuePhase.length > 0">
          <th class="fw-bold align-middle" nowrap scope="col">Prescrizione</th>
          <th class="fw-bold align-middle" nowrap scope="col">N. Elementi</th>
          <th scope="col">
            <button class="btn btn-sm btn-violet text-uppercase"
                    :disabled="numberOfSelected <= 1"
                    @click="completedAllSelected()">
              concludi tutti
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="worksGroupedByTestWorkQueuePhase.length > 0">
          <template v-for="(el, index) in worksGroupedByTestWorkQueuePhase" :key="index">
            <tr class="text-center" :class="{'higthlight': el.checked}">
              <td>{{ el.works[0].number_text }} - {{ dateFormatter(el.delivery_date, { onlyDate: true, onlyTime: false, dash: false, iso: false }) }}</td>
              <td>{{ el.works.length }}</td>
              <td>
                <button class="btn btn-violet text-uppercase"
                        :disabled="! el.checked"
                        @click="completed(el.test_work_queue_phase_id, el.works)">
                  concludi
                </button>
              </td>
            </tr>
          </template>
        </template>
        <template v-else>
          <tr>
            <td colspan="7" class="text-center p-3 fw-bold">Nessun lavoro presente</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>

  <Confirm
    v-if="showBlockModal"
    modal_id="modalBlockWorks"
    :title="modalText.title"
    :subtitle="modalText.subtitle"
    :confirm_label="(missingDownloads && missingDownloads.length > 0) ? 'Chiudi' : 'Si'"
    :decline_label="(missingDownloads && missingDownloads.length > 0) ? '' : 'No'"
    @confirm="(missingDownloads && missingDownloads.length > 0) ? hideBlockModal(false) : proceedAnyway()"
    @decline="hideBlockModal(false)"
    @hidden="hideBlockModal(false)"
  >
    <div v-if="missingDownloads && missingDownloads.length > 0" class="mb-3">
      <div v-for="(work, index) in missingDownloads" :key="`missing-` + index" class="mb-3">
        <div class="fw-bold mb-2">{{ work.prescription_test?.device?.name }} | {{ work.number_text }} - {{ work.first_name }} {{ work.last_name }}</div>
        <div class="text-muted small mb-1">{{ dateFormatter(work.delivery_date, {onlyDate: true, onlyTime: true, dash: false, iso: false}) }}</div>
        <div class="mb-1">Materiale: {{ work.material }}</div>
        <div class="mb-1">Colore: {{ work.code || '-' }}</div>
        <div class="mb-1">Stato: {{ work.state }}</div>
        <template v-if="work.media && work.media.length > 0">
          <div class="mb-1">File: {{ work.media[0].file_name }}</div>
        </template>
      </div>
    </div>

    <div v-if="worksNotCompleted.length > 0" class="mb-3">
      <div v-for="(numberText, index) in worksNotCompleted" :key="index" class="mb-3">
        <div class="fw-bold mb-2">{{ numberText.prescription_test?.device?.name }} | {{ numberText.number_text }} - {{ numberText.first_name }} {{ numberText.last_name }}</div>
        <div class="text-muted small mb-1">{{ dateFormatter(delivery_date, {onlyDate: true, onlyTime: true, dash: false, iso: false}) }}</div>
        <div class="mb-1">Materiale: {{ numberText.material }}</div>
        <div class="mb-1">Colore: {{ numberText.code }}</div>
        <div class="mb-1">Stato: {{ numberText.state }}</div>
      </div>
    </div>
  </Confirm>

</template>

<script>
import { computed, ref, toRaw, watch, inject } from "vue";
import _ from 'lodash';
import _head from "lodash/head";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import { update } from "@/use/repositories/assets/update";
import { dateFormatter } from '@/use/utilities/time/dateFormatter';
import { useBarCodeValidator } from "@/composables/useBarCodeValidator";
import Confirm from "@/components/Modal/Confirm.vue";

export default {
  name: "FinishWork",
  components: { Confirm },
  emits: [
    'idsToRemove',
    'idsMovedToInTheWorks',
    'resetscanCodeProp',
    'restore',
  ],
  props: [
    'dataAssets',
    'scanCode',
    'reset',
  ],
  setup(props, { emit }) {
    const i18n = useI18n();
    const { validateInput } = useBarCodeValidator();
    const constants = inject('constants');
    const worksGroupedByTestWorkQueuePhase = ref([]);
    const ovenWorksGroupedByTestWorkQueuePhase = ref([]);
    const idsToUpdate = ref([]);
    const showBlockModal = ref(false);
    const missingDownloads = ref([]);
    const modalMode = ref(null);
    const toast = useToast();
    const numberOfSelected = computed(() => {
      let counter = 0;
      worksGroupedByTestWorkQueuePhase.value.forEach((item) => {
        if (item.checked) {
          counter++;
        }
      });

      return counter;
    });
    const worksNotCompleted = ref([]);
    const selectedOvenWorks = computed(() => {
      return ovenWorksGroupedByTestWorkQueuePhase.value.filter((item) => item.checked);
    });
    const modalText = computed(() => {
      if (missingDownloads.value && missingDownloads.value.length > 0) {
        return {
          title: missingDownloads.value.length === 1 ? i18n.t('Esiste un progetto non scaricato') : i18n.t('Esistono progetti non scaricati'),
          subtitle: i18n.t('Non è possibile concludere la lavorazione: alcuni asset non sono stati scaricati. Scarica tutti i file prima di procedere.'),
        }
      }
      return {
        title: worksNotCompleted.value.length === 1 ? i18n.t('The following work is not completed!') : i18n.t('The following works are not completed!'),
        subtitle: worksNotCompleted.value.length === 1 ? i18n.t('Do you want to finish it the same?') : i18n.t('Do you want to finish them all the same?'),
      }
    });

    watch(() => props.reset, async (value) => {
      if (value) {
        worksGroupedByTestWorkQueuePhase.value.forEach((item) => item.checked = false);
        emit('restore');
      }
    });

    watch(() => props.dataAssets.map((asset) => `${asset.id}:${asset.state}:${asset.test_work_queue_phase_id}`).join('|'), async () => {
      // Reorder by priority date.
      let value = _.orderBy(toRaw(props.dataAssets),'delivery_date', 'asc');
      // Grouped data.
      await groupedByTestWorkQueuePhase(toRaw(value));
    });

    watch(() => props.scanCode, (value) => {
      const searchKey = validateInput(value);

      worksGroupedByTestWorkQueuePhase.value.forEach((item) => {
        if (searchKey === 'device' && _head(item.works).prescription_test?.device?.name === value) {
          item.checked = !item.checked;
        } else if (searchKey === 'number_text' && _head(item.works).number_text === value) {
          item.checked = !item.checked;
        }
      });

      worksGroupedByTestWorkQueuePhase.value = _.orderBy(toRaw(worksGroupedByTestWorkQueuePhase.value), 'checked', 'desc');
      document.getElementById('scrollTop').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
      emit('resetscanCodeProp', "");
    });

    const groupedByTestWorkQueuePhase = async (allWorks) => {
      const filteredInTheWorkState = _.uniqBy(allWorks.filter((work) => work.state === constants.states.IN_THE_WORKS),'id');
      const filteredReadyForOvenState = _.uniqBy(allWorks.filter((work) => work.state === constants.states.READY_FOR_OVEN),'id');
      // Grouped by TWQP.
      worksGroupedByTestWorkQueuePhase.value =
          _.chain(filteredInTheWorkState)
            .groupBy('test_work_queue_phase_id')
            .map((value, key) => ({ test_work_queue_phase_id: key, works: value }))
            .value();

      // Add checked bool for field before render.
      worksGroupedByTestWorkQueuePhase.value.forEach((item) => item.checked = false);
      // Add priority date.
      worksGroupedByTestWorkQueuePhase.value.forEach((item) => {
        item.delivery_date = item.works[0].delivery_date;
      });
      // Order by priority date.
      worksGroupedByTestWorkQueuePhase.value = _.orderBy(toRaw(worksGroupedByTestWorkQueuePhase.value), 'delivery_date', 'asc');

      ovenWorksGroupedByTestWorkQueuePhase.value =
        _.chain(filteredReadyForOvenState)
          .groupBy('test_work_queue_phase_id')
          .map((value, key) => ({ test_work_queue_phase_id: key, works: value }))
          .value();

      ovenWorksGroupedByTestWorkQueuePhase.value.forEach((item) => {
        item.checked = false;
        item.delivery_date = item.works[0].delivery_date;
      });
      ovenWorksGroupedByTestWorkQueuePhase.value = _.orderBy(toRaw(ovenWorksGroupedByTestWorkQueuePhase.value), 'delivery_date', 'asc');
    }

    const completed = async (testWorkQueuePhaseId, works) => {
      idsToUpdate.value = [];
      worksNotCompleted.value = [];
      missingDownloads.value = [];
      modalMode.value = null;

      // Find ids to remove.
      await fetchIdsToConclude(testWorkQueuePhaseId);

      syncWorksNotCompleted(works);

      const pendingSamePhase = _.filter(toRaw(props.dataAssets), (item) => {
        return item.test_work_queue_phase_id === parseInt(testWorkQueuePhaseId) && item.state === constants.states.PENDING;
      });
      if (pendingSamePhase.length) {
        missingDownloads.value = pendingSamePhase;
        modalMode.value = 'missing';
      }

      if (!worksNotCompleted.value.length && !missingDownloads.value.length) {
        await finishWork(toRaw(idsToUpdate.value), constants.states.COMPLETED).then(() => {
          // Show message
          toast.success('Lavorazione conclusa con successo!', {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
          });
        });

      } else {
        // Show block modal.
        showBlockModal.value = true;
      }
    }

    const fetchIdsToConclude = async (testWorkQueuePhaseId) => {
      props.dataAssets.forEach((item) => {
        if (
          item.test_work_queue_phase_id === parseInt(testWorkQueuePhaseId) &&
          item.state === constants.states.IN_THE_WORKS
        ) {
          idsToUpdate.value.push(item.id);
        }
      });
    }

    const finishWork = async (ids, state) => {
      try {
        await update(ids, state).then(async () => {
          emit('idsToRemove', ids);
        });
      } catch (error) {
        alert(error);
      } finally {
        idsToUpdate.value = [];
      }
    }

    const putSelectedWorksInOven = async () => {
      const selectedWorks = toRaw(selectedOvenWorks.value);
      const ids = _.uniq(_.flatMap(selectedWorks, (item) => item.works.map((work) => work.id)));
      const selectedElementsCount = _.sumBy(selectedWorks, (item) => item.works.length);

      try {
        await update(ids, constants.states.IN_THE_WORKS).then(() => {
          emit('idsMovedToInTheWorks', ids);
          toast.success(`${selectedElementsCount} ${selectedElementsCount === 1 ? 'elemento messo' : 'elementi messi'} in forno con successo!`, {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
        });
      } catch (error) {
        alert(error);
      }
    }

    const renderUniqueValues = (works, field) => {
      const values = _.uniq(works.map((work) => work[field] || '-'));
      return values.join(' / ');
    }

    const proceedAnyway = async () => {
      console.log(_.uniq(toRaw(idsToUpdate.value)));

      await finishWork(_.uniq(toRaw(idsToUpdate.value)), constants.states.COMPLETED).then(() => {
        // Show message
        toast.success('Operazione avvenuta con successo!', {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      });
    }

    const hideBlockModal = (value) => {
      showBlockModal.value = value;
      if (!value) {
        missingDownloads.value = [];
        worksNotCompleted.value = [];
        modalMode.value = null;
      }
    }

    const orderByPriorityDate = () => {
      worksGroupedByTestWorkQueuePhase.value = _.orderBy(toRaw(worksGroupedByTestWorkQueuePhase.value), 'delivery_date', 'asc');
      // Show message
      toast.success("Ordinamento lavorazioni per data di priorità", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        }
      );
    }

    const completedAllSelected = async () => {
      worksNotCompleted.value = [];
      missingDownloads.value = [];
      modalMode.value = null;

      worksGroupedByTestWorkQueuePhase.value.forEach((item) => {
        if (item.checked) {
          // Find ids to remove.
          fetchIdsToConclude(item.test_work_queue_phase_id);
          syncWorksNotCompleted(item.works);

          const pendingSamePhase = _.filter(toRaw(props.dataAssets), (work) => {
            return work.test_work_queue_phase_id === parseInt(item.test_work_queue_phase_id) && work.state === constants.states.PENDING;
          });
          if (pendingSamePhase.length) {
            missingDownloads.value = missingDownloads.value.concat(pendingSamePhase);
            modalMode.value = 'missing';
          }
        }
      });

      if (worksNotCompleted.value.length || missingDownloads.value.length) {
        showBlockModal.value = true;
      } else {
        await proceedAnyway();
      }
    }

    const syncWorksNotCompleted = (works) => {
      works.forEach((work) => {
        if (work.state === constants.states.PENDING) {
          worksNotCompleted.value.push(work);
        } else if (work.state === constants.states.MISSING_DOWNLOAD) {
          missingDownloads.value.push(work);
        }
      });
    }

    return {
      worksGroupedByTestWorkQueuePhase,
      ovenWorksGroupedByTestWorkQueuePhase,
      completed,
      idsToUpdate,
      showBlockModal,
      hideBlockModal,
      proceedAnyway,
      orderByPriorityDate,
      completedAllSelected,
      numberOfSelected,
      selectedOvenWorks,
      putSelectedWorksInOven,
      renderUniqueValues,
      worksNotCompleted,
      missingDownloads,
      dateFormatter,
      modalText,

    }
  }
}
</script>

<style scoped>
:deep(.table thead) {
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
  --bs-table-bg: rgb(225, 210, 242) !important;
  --bs-table-border-color: rgb(225, 210, 242) !important;
}
:deep(.higthlight) {
  box-shadow: 0 0 0 0.25rem rgb(225, 210, 242) !important;
  --bs-table-bg: rgb(225, 210, 242) !important;
  --bs-table-active-bg: rgb(225, 210, 242) !important;
  --bs-table-hover-bg: rgb(225, 210, 242) !important;
  --bs-table-border-color: rgb(225, 210, 242) !important;
}
.sync:hover {
  cursor: pointer;
}
.worksNotCompleted {
  overflow: auto;
  max-height: 350px;
}
</style>
